/* ============================================================
   EroticShop — Article Reading UX (TOC + aktif başlık vurgusu)
   Dosya  : assets/article-reading.js
   Yalnız blog article template'inde (main-article.liquid) defer ile yüklenir.
   Vanilla ES6+, kütüphane yok. Mobile-first.
   ============================================================ */
(() => {
  'use strict';

  const content = document.querySelector('.article-template__content');
  if (!content) return;

  /* ── Türkçe-güvenli slug (ç/ğ/ı/İ/ö/ş/ü → ascii) ── */
  const TR = { 'ç':'c','Ç':'c','ğ':'g','Ğ':'g','ı':'i','İ':'i','ö':'o','Ö':'o','ş':'s','Ş':'s','ü':'u','Ü':'u' };
  const slugify = (s) =>
    (s || '')
      .replace(/[çÇğĞıİöÖşŞüÜ]/g, (m) => TR[m])
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'bolum';

  /* ──────────────────────────────────────────────
     TOC (İçindekiler) + aktif başlık vurgusu
     h2 + h3, iki seviye. <3 başlıkta gizlenir.
     ────────────────────────────────────────────── */
  const initToc = () => {
    const toc = document.querySelector('.es-toc');
    const list = toc && toc.querySelector('.es-toc__list');
    if (!toc || !list) return;

    const headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));

    // Kısa yazı → TOC gösterme
    if (headings.length < 3) { toc.hidden = true; return; }

    const used = new Set();
    const links = new Map();
    const frag = document.createDocumentFragment();

    headings.forEach((h) => {
      // Mevcut id'yi koru; yoksa slug üret (çakışma guard)
      let id = h.id || slugify(h.textContent);
      let base = id, i = 2;
      while (used.has(id)) { id = base + '-' + i; i++; }
      used.add(id);
      h.id = id;

      const li = document.createElement('li');
      li.className = 'es-toc__item';

      const a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = (h.textContent || '').trim();
      a.className = 'es-toc__link es-toc__link--' + h.tagName.toLowerCase();

      a.addEventListener('click', (ev) => {
        ev.preventDefault();
        const reduce = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (e) {}
      });

      li.appendChild(a);
      frag.appendChild(li);
      links.set(id, a);
    });

    list.appendChild(frag);
    toc.hidden = false;

    /* ── Aktif başlık vurgusu ── */
    if ('IntersectionObserver' in window) {
      let activeId = null;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.id;
          if (id === activeId) return;
          if (activeId && links.get(activeId)) links.get(activeId).classList.remove('is-active');
          const link = links.get(id);
          if (link) { link.classList.add('is-active'); activeId = id; }
        });
      }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });
      headings.forEach((h) => io.observe(h));
    }
  };

  initToc();
})();